// File: MetricItem.js
import React from "react";

const MetricItem = ({ label, value }) => {
  return (
    <div className="relative pt-1">
      <div className="flex items-center justify-between">
        <div>
          <span className="text-xs font-medium text-gray-500">{label}</span>
        </div>
        <div>
          <span className="text-xs font-semibold text-indigo-700">{value}</span>
        </div>
      </div>
    </div>
  );
};

export default MetricItem;
